import NewsList from '../../components/NewsList';
import PageCenterContainer from '../../components/PageCenterContainer';
import PageHeader from '../../components/PageHeader';
import './NewsPage.scss';

const NewsPage = () => {
  return (
    <PageCenterContainer>
      <div className="newspage-container">
        <PageHeader text="Legfrissebb híreink" />
        <NewsList />
      </div>
    </PageCenterContainer>
  );
};

export default NewsPage;
